import { Box, Button } from "@chakra-ui/react";

type IProps = {
  onSkip?: () => void;
  onBack?: () => void;
  showLabel?: string;
};

const AuthHeader = (props: IProps) => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      mb={"2rem"}
    >
      {props.onBack && (
        <Box>
          <Button variant={"outline"} onClick={props.onBack}>
            Back
          </Button>
        </Box>
      )}
      {props.onSkip && (
        <Box
          as="button"
          fontWeight={"600"}
          onClick={props.onSkip}
          border="2px solid"
          borderColor={"transparent"}
          px={".4rem"}
          py=".2rem"
          borderRadius={".4rem"}
          cursor={"pointer"}
          color={"primary300"}
          _hover={{ border: "2px solid black" }}
          _focus={{ outlineOffset: "1rem" }}
        >
          Skip
        </Box>
      )}
    </Box>
  );
};

export default AuthHeader;
